module.exports = __webpack_public_path__ + "media/images/golden_pin_concept_design_award_icon@2x-1a3a6acc8041a4283eed7a6cab63be74.png";